import React from "react";
import { FAQ, FAQTitle, FAQTxt, FAQContent } from "./faqStyle";
const Faq = () => {
  return (
    <FAQ>
      <FAQTitle>Faq</FAQTitle>
      <FAQTxt>Frequently asked questions</FAQTxt>
      <FAQContent>axxa</FAQContent>
    </FAQ>
  );
};

export default Faq;
